export const EVENT_ALERT_STATUS = 'EVENT_ALERT_STATUS'
export const LANGUAGE_ALERT_STATUS = 'LANGUAGE_ALERT_STATUS'
export const MEMBERS_ALERT_STATUS = 'MEMBERS_ALERT_STATUS'
export const NOTICE_ALERT_STATUS = 'NOTICE_ALERT_STATUS'